<template>
	<div>
		<el-button class="add-btn-1" type="primary" @click="Submit">{{props.text}}</el-button>
	</div>
</template>

<script lang="ts" setup>
	import translate from '@/api/translate';

	const props = defineProps({
		text: {
			type: String,
			default: translate.ShowText('添加')
		}
	})

	const emits = defineEmits(["change"]);

	const Submit = () => {
		emits("change");
	};
</script>

<style lang="scss" scope>
	.add-btn-1 {
		min-width: 70px;
		padding-left: 20px;
		padding-right: 20px;
		// height: 36px;
		border-radius: 4px;
		font-size: 14px;
		// line-height: 36px;
	}
</style>